import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'petrol' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-gold text-petrolDark shadow-[0_10px_28px_rgba(212,175,55,.30)] hover:bg-[#E4C255]',
    petrol: 'bg-petrol text-white shadow-[0_10px_28px_rgba(122,63,242,.28)] hover:bg-deep',
    outline: 'border-2 border-gold bg-transparent text-gold hover:bg-gold hover:text-petrolDark'
  };
  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-4 text-sm sm:px-8 sm:text-base'
  };
  const classes = `inline-flex items-center justify-center gap-2 rounded-xl font-extrabold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/45 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-260" data-mp="tmnfi98uioef">
        {children}
        {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-261" data-mp="onkgp6jgleew" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-262" data-mp="12mtlla27sm3k">
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-263" data-mp="xnqsmnzie6by" />}
    </button>;
}